import ServicePage from '../../components/service/ServicePage'

export default function PadPrinting() {
  return <ServicePage service="pad" lang="en" />
}
